import { PlanTier } from '@shared/price-plan/enums';

export const PLANS_BENEFITS: Record<PlanTier, string[]> = {
  [PlanTier.free]: [
    'Organized digital waitlist',
    'Customizable notifications',
    'Self check-in',
    'Embed on your website',
    'Real-time sync',
  ],
  [PlanTier.premium]: [
    'Online bookings & reservations',
    '2-way chat',
    'Square & Reserve with Google integrations',
    'SMS Automations & Saved Replies',
    'To Go List',
  ],
  [PlanTier.starter]: [
    'More messages & guests',
    'Unlimited users',
    '2-way SMS chat',
    'Basic reservations',
    'Predicted wait times',
    'Detailed analytics',
  ],
  [PlanTier.business]: [
    'Online bookings',
    'Table management',
    'Square & Google integrations',
    'Payments with Stripe',
    'Custom form properties',
    'Saved replies',
    'SMS automations',
    'Geofencing',
    'To-go list',
    'Data exports',
  ],
};
